export default "__VITE_ASSET__c99e313c__"